/**
 * Normaliza dados da API que podem vir em diferentes formatos:
 * - Array direto: [1, 2, 3]
 * - Objeto com data: { data: [1, 2, 3] }
 * - Objeto aninhado: { data: { data: [1, 2, 3] } }
 *
 * @param {any} data - Dados retornados da API
 * @returns {Array} Array normalizado ou array vazio
 */
export const normalizeApiData = (data) => {
  // Se já é um array, retorna diretamente
  if (Array.isArray(data)) return data;

  // Se não existe ou é null/undefined, retorna array vazio
  if (!data) return [];

  // Se tem data.data (aninhado)
  if (data.data?.data && Array.isArray(data.data.data)) {
    return data.data.data;
  }

  // Se tem data (primeiro nível)
  if (data.data && Array.isArray(data.data)) {
    return data.data;
  }

  // Caso padrão: retorna array vazio
  return [];
};

/**
 * Normaliza URLs de imagens da API
 * - Remove barras invertidas escapadas (\/ -> /)
 * - Adiciona public/ antes de storage/ se necessário
 * - Garante que a URL esteja correta
 *
 * @param {string|null|undefined} url - URL da imagem que pode vir com barras invertidas escapadas
 * @param {string} baseUrl - URL base da API (opcional)
 * @returns {string} URL normalizada
 */
export const normalizeImageUrl = (url, baseUrl) => {
  if (!url || typeof url !== 'string') return '';

  // Se já é uma URL completa (começa com http), normalizar apenas as barras
  if (url.startsWith('http://') || url.startsWith('https://')) {
    // Remover barras invertidas escapadas
    let normalized = url.replace(/\\/g, '/');

    // Se contém /storage/ e não tem /public/ antes, adicionar
    if (normalized.includes('/storage/') && !normalized.includes('/public/storage/')) {
      normalized = normalized.replace('/storage/', '/public/storage/');
    }

    return normalized;
  }

  // Se é um caminho relativo, normalizar
  let normalized = url.replace(/\\/g, '/');

  // Remover barras duplicadas
  normalized = normalized.replace(/\/+/g, '/');

  // Se contém storage/ e não tem public/ antes, adicionar
  if (normalized.includes('storage/') && !normalized.includes('public/storage/')) {
    normalized = normalized.replace('storage/', 'public/storage/');
  }

  // Se tem baseUrl, construir URL completa
  if (baseUrl) {
    const cleanBaseUrl = baseUrl.replace(/\/$/, ''); // Remove barra final se existir
    const cleanPath = normalized.startsWith('/') ? normalized : `/${normalized}`;
    return `${cleanBaseUrl}${cleanPath}`;
  }

  return normalized;
};
